import { FC } from 'react';

import { IconProps } from './types';

export const CardV4Icon: FC<IconProps> = () => {
  return (
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.125 8.75C6.39911 8.75 5 10.1491 5 11.875V12.6562H35V11.875C35 10.1491 33.6009 8.75 31.875 8.75H8.125ZM5 28.125V17.3438H35V28.125C35 29.8509 33.6009 31.25 31.875 31.25H8.125C6.39911 31.25 5 29.8509 5 28.125ZM2.5 11.875C2.5 8.7684 5.0184 6.25 8.125 6.25H31.875C34.9816 6.25 37.5 8.7684 37.5 11.875V28.125C37.5 31.2316 34.9816 33.75 31.875 33.75H8.125C5.0184 33.75 2.5 31.2316 2.5 28.125V11.875ZM10 21.0938C8.70558 21.0938 7.65625 22.1431 7.65625 23.4375V25C7.65625 26.2944 8.70558 27.3438 10 27.3438H13.75C15.0444 27.3438 16.0938 26.2944 16.0938 25V23.4375C16.0938 22.1431 15.0444 21.0938 13.75 21.0938H10Z"
        fill="#CEFFF4"
        fillOpacity="0.5"
      />
    </svg>
  );
};
